<template>
    <ul class="breadcrumbs list-unstyled">
        <li v-for="(breadcrumb, index) in breadcrumbs" :key="'breadcrumb' + index" class="breadcrumbs__item">
            <Link :link="breadcrumb.link" class="breadcrumbs__link">{{ breadcrumb.text }}</Link>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'Breadcrumbs',

    props: {
        breadcrumbs: {
            type: Array,
            required: true
        }
    }
};
</script>

<style scoped lang="scss">
@use '@/styles/mixins';

.breadcrumbs {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;

    &__item {
        margin-right: 0.3em;

        &:not(:first-child) {
            &::before {
                content: '/';
                margin-right: 0.3em;
            }
        }
    }

    &__link {
        color: var(--body-color);
    }

    @include mixins.mobile-only {
        font-size: 14px;
    }
}
</style>
